import { ArrowDown, ArrowRight } from "lucide-react";
import HeroCollage from "./HeroCollage";
import { CTA_LABEL } from "@/content/site";

const Hero = () => (
  <section className="relative overflow-hidden bg-paper pt-[72px]">
    <div aria-hidden="true" className="bg-grid mask-fade-top pointer-events-none absolute inset-0" />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -top-40 right-[-12%] h-[640px] w-[640px] rounded-full bg-brand-400/25 blur-[140px]"
    />

    <div className="relative mx-auto grid max-w-page items-center gap-16 px-5 pb-24 pt-10 sm:px-8 sm:pt-12 lg:grid-cols-12 lg:gap-10 lg:pb-28 lg:pt-20">
      <div className="lg:col-span-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-brand-200 bg-white/80 px-3.5 py-1.5 font-mono text-[11px] font-medium uppercase tracking-[0.12em] text-brand-700 backdrop-blur sm:text-[11.5px]">
          <span className="relative flex h-2 w-2" aria-hidden="true">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-500 opacity-60" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-brand-600" />
          </span>
          Software · IA · Automação
        </span>

        <h1 className="mt-7 text-balance text-[38px] font-semibold leading-[1.04] tracking-[-0.04em] text-ink-900 sm:text-[54px] lg:text-[52px] xl:text-[64px]">
          O time de <span className="text-brand-600">tecnologia e IA</span> que a sua empresa ainda não tem
        </h1>

        <p className="mt-7 max-w-[540px] text-lg leading-relaxed text-ink-600 sm:text-xl">
          Desenvolvemos software sob medida, automatizamos a operação e mostramos, na prática, como aplicar IA no seu
          negócio. Da estratégia ao sistema rodando.
        </p>

        <div className="mt-9 flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center">
          <a href="#contact" className="btn-primary group">
            {CTA_LABEL}
            <ArrowRight className="h-[18px] w-[18px] transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
          </a>
          <a
            href="#projects"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-5 py-4 text-base font-medium text-ink-800 transition hover:text-brand-700"
          >
            Ver soluções
            <ArrowDown className="h-4 w-4" aria-hidden="true" />
          </a>
        </div>
      </div>

      <div className="lg:col-span-6">
        <HeroCollage />
      </div>
    </div>
  </section>
);

export default Hero;
